/* Source: /home/sidsolaiyappan/skooch_ai/shared/learned_profile_read.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { get_supabase } from "./supabase_config.js";
async function readLearnedProfileForConsent(uid) {
  if (!uid) {
    return null;
  }
  try {
    let _sb = get_supabase();
    let _resp = await _sb.from("learned_profile").select("learned_focus_peak,last_asked_at,familiarity,focus_peak_confidence").eq("user_id", uid).maybeSingle();
    if (!_resp) {
      return null;
    }
    if (_resp.error) {
      return null;
    }
    let _row = _resp.data;
    if (!_row) {
      return null;
    }
    let _peak = (_row.learned_focus_peak ? _row.learned_focus_peak : "");
    let _lastAsked = (_row.last_asked_at ? _row.last_asked_at : "");
    let _fam = (((_row.familiarity !== undefined) && (_row.familiarity !== null)) ? _row.familiarity : 0);
    let _conf = (((_row.focus_peak_confidence !== undefined) && (_row.focus_peak_confidence !== null)) ? _row.focus_peak_confidence : 0);
    return {"learned_focus_peak": _peak, "last_asked_at": _lastAsked, "familiarity": _fam, "focus_peak_confidence": _conf};
  } catch (__jac_e) {
    if (true) {
      let _e = __jac_e;
      return null;
    } else {
      throw __jac_e;
    }
  }
}
async function getLearnedProfileViaTransport(uid, tok) {
  if (window.__skoochServerless) {
    return await readLearnedProfileForConsent(uid);
  }
  let _p = window.__skoochJacCall("get_learned_profile", {"user_id": uid, "access_token": tok});
  _p = _p.catch(e => {
    return null;
  });
  return await _p;
}
async function markLearnedProfileAskedViaTransport(uid, tok) {
  if (window.__skoochServerless) {
    if (!uid) {
      return null;
    }
    try {
      let _sb = get_supabase();
      let _nowIso = Reflect.construct(Date, []).toISOString();
      let _resp = await _sb.from("learned_profile").upsert({"user_id": uid, "last_asked_at": _nowIso}, {"onConflict": "user_id"});
      return null;
    } catch (__jac_e) {
      if (true) {
        let _e = __jac_e;
        return null;
      } else {
        throw __jac_e;
      }
    }
  }
  let _p = window.__skoochJacCall("mark_learned_profile_asked", {"user_id": uid, "access_token": tok});
  _p = _p.catch(e => {
    return null;
  });
  return await _p;
}
export {getLearnedProfileViaTransport, markLearnedProfileAskedViaTransport, readLearnedProfileForConsent};
//# sourceMappingURL=learned_profile_read.js.map
